export default __webpack_public_path__ + "static/media/costsplitter.c8bf5657.png";